import { getAccountData } from "@/service/payments";
import { AccountData } from "@/types/auth";
import { createResource } from "@/utils/createResource";

const accountResource = createResource<AccountData>((force) =>
  getAccountData({ forceRefresh: force }),
);

export const refreshAccountData = () => accountResource.refresh();

// Dados cadastrais da conta atual (GET da conta), compartilhados pelo app.
export const useAccount = () => {
  const { data, loading, error, refresh } = accountResource.useResource();
  return { account: data, loading, error, refreshAccount: refresh };
};
